//@ts-nocheck
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDDropzone from "components/MDDropzone";
import React, { useEffect, useState } from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import MDSnackbar from "../../../../components/MDSnackbar";
import MDProgress from "components/MDProgress";
import { Autocomplete, IconButton, TextField, Tooltip } from "@mui/material";
import CustomModal from "components/CustomModal";
import { get, post } from "../../../../requests";
import FullPageLoader from "../../../../components/Loader/FullPage";
import PlaidComponent from "./PlaidComponent";
import FlinksComponent from "./FlinksComponent";
import InfoIcon from "@mui/icons-material/Info";
import CustomDialog from "../../../../components/CustomCard";
import StatusTable from "../../../../lib/Tables/StatusTable";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import RefreshIcon from "@mui/icons-material/Refresh";
import ExcelExportUtil from "../../../../utils/DataExportUtils";
import { styled } from "@mui/material/styles";
import StorageUtils from "../../../../utils/StorageUtils";
import { SendTimeExtension } from "@mui/icons-material";

const StatementsToolbar = ({
  applicationId,
  refreshStatements,
  setSelectedBank,
  loadBanksFromServer,
  loadFlinksBanksFromServer,
  handleAccountRefresh,
  refreshAll,
  merchantId,
  showOcrTransactionsModal = false,
  setShowOcrTransactionsModal = () => {},
  renderOcrAccountSelection = () => null,
  onRunOcrTransactions = () => {},
  ocrAccounts = [],
  plaidBanks = [],
  plaidApiError = null,
  setPlaidApiError = () => {},
  flinksBanks = [],
  flinksApiError = null,
  setFlinksApiError = () => {},
}: any) => {
  const uploadFile = useStoreActions((actions: any) => actions.fileUploads.uploadFile);
  const getMediaAttachments = useStoreActions(
    (actions: any) => actions.fileUploads.getMediaAttachments
  );
  const mediaAttachments = useStoreState((state: any) => state.fileUploads.mediaAttachments);

  const [alert, setAlert] = useState<{
    type: "success" | "error" | "warning" | null;
    message: any;
    timeOut: number;
  } | null>(null);
  const [uploadingFiles, setUploadingFiles] = useState<string[]>([]);
  const [open, setOpen] = useState(false);
  const [files, setFiles] = useState<any[]>([]);
  const [selectedFiles, setSelectedFiles] = useState<any[]>([]);
  const [isUploading, setIsUploading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [publicToken, setPublicToken] = useState(null);
  const [showOCRPopUp, setShowOCRPopUp] = useState(false);
  const [showOCRLogs, setShowOCRLogs] = useState(false);
  const [ocrLogs, setOcrLogs] = useState<any[]>([]);
  const [showLendPathway, setShowLendPathway] = useState(false);
  const [showOcrolous, setShowOcrolous] = useState(false);

  useEffect(() => {
    if (applicationId) {
      getMediaAttachments({ dealApplicationId: applicationId });
    }
  }, [applicationId, getMediaAttachments]);

  useEffect(() => {
    if (mediaAttachments.length > 0) {
      const statementsFile = mediaAttachments.filter(
        (file: any) => file.category === "Bank Statements"
      );
      setFiles(statementsFile);
    }
  }, [mediaAttachments]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setSelectedFiles([]);
    setOpen(false);
  };

  const handleFileSelect = (event: any, newValue: any) => {
    setSelectedFiles(newValue.map((option: any) => option.value));
  };

  const handleSubmit = () => {
    runMoneyThumb();
    handleClose();
  };

  const handleRunOcr = () => {
    runOCR();
    setShowOCRPopUp(false);
    setSelectedFiles([]);
  };

  const handleLendPathWay = () => {
    setShowLendPathway(false);
    setSelectedFiles([]);
  };

  useEffect(() => {
    let intervalId: NodeJS.Timeout;

    if (showOCRLogs) {
      fetchOCRLogs();
      intervalId = setInterval(() => {
        fetchOCRLogs();
      }, 30000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [showOCRLogs]);

  const handleOcrSubmit = async () => {
    if (selectedOcrAccounts.length === 0) {
      setAlert({
        type: "error",
        message: "Please select at least one account.",
      });
      return;
    }

    try {
      await onRunOcrTransactions(selectedOcrAccounts);
      setAlert({
        type: "success",
        message: "OCR transactions initiated successfully.",
      });
    } catch (error) {
      console.error("Error running transactions with OCR:", error);
      setAlert({
        type: "error",
        message: "Failed to run OCR transactions.",
      });
    } finally {
      setShowOcrTransactionsModal(false);
    }
  };

  const runOcrolous = async () => {
    if (selectedFiles.length === 0) {
      setAlert({
        type: "warning",
        message: "Please select files before running Ocrolous.",
      });
      return;
    }

    try {
      setIsSubmitting(true);

      const response = await post(
        "integration/ocrolous/uploadApplicationStatements",
        {
          dealApplicationId: applicationId,
          mediaAttachmentIds: selectedFiles,
        },
        { timeout: 0 }
      );

      setAlert({
        type: "success",
        message: (
          <>
            <strong>Files uploaded successfully.</strong>
            <br />
            Ocrolous has accepted the files for processing.
            <br />
          </>
        ),
        timeOut: 30000,
      });

      refreshAll(applicationId);
    } catch (error) {
      console.error("Error submitting files to Ocrolous:", error);
      setAlert({
        type: "error",
        message: "An error occurred while processing with Ocrolous.",
      });
    } finally {
      setIsSubmitting(false);
      setIsUploading(false);
      setShowOcrolous(false);
      setSelectedFiles([]);
    }
  };

  const handleOcrAccountSelect = (event: any, newValue: any) => {
    setSelectedOcrAccounts(newValue.map((option: any) => option.value));
  };

  const handleFileDrop = async (files: File[]) => {
    const failedFiles: string[] = [];
    let successFiles = 0;
    const totalFiles = files.length;

    if (totalFiles === 0) {
      setAlert({
        type: "error",
        message: "No valid files present. Max Upload size is 40 files.",
      });
      return;
    }

    for (const file of files) {
      let UUID = Math.random() * 9000 + "" + Date.now();

      try {
        await uploadFile({
          file,
          tenantId: 1,
          mediaToken: UUID,
          dealApplicationId: applicationId,
          description: "",
          category: "Bank Statements",
        });

        successFiles++;
      } catch (error) {
        failedFiles.push(file.name);
      }
    }

    if (failedFiles.length > 0) {
      setAlert({
        type: "error",
        message: `Error uploading the following files: ${failedFiles.join(", ")}`,
      });
    } else if (successFiles === totalFiles) {
      setAlert({
        type: "success",
        message: "All files uploaded successfully!",
      });
    } else {
      setAlert({
        type: "warning",
        message: "Some files failed to upload.",
      });
    }

    setUploadingFiles([]);
    getMediaAttachments({ dealApplicationId: applicationId });
  };

  const runMoneyThumb = async () => {
    if (selectedFiles.length === 0) {
      setAlert({
        type: "warning",
        message: "Please select files before running MoneyThumb.",
      });
      return;
    }
    try {
      setIsSubmitting(true);
      const config = { timeout: 0 };
      const response = await post(
        "moneythumb/uploadApplicationStatements",
        {
          appId: applicationId,
          mediaAttachmentIds: selectedFiles,
        },
        config
      );

      if (response && response.async) {
        setAlert({
          type: "warning",
          message: "MoneyThumb is processing some statements. Please REFRESH after some time.",
        });
      } else {
        setAlert({
          type: "success",
          message: "MoneyThumb processed successfully!",
        });
      }

      refreshAll(applicationId);
    } catch (error) {
      console.error("Error submitting files:", error);
      setAlert({
        type: "error",
        message: "An error occurred while processing with MoneyThumb.",
      });
    } finally {
      setIsSubmitting(false);
      setIsUploading(false);
    }
  };

  const runOCR = async () => {
    if (selectedFiles.length === 0) {
      setAlert({
        type: "warning",
        message: "Please select files before running OCR.",
      });
      return;
    }

    try {
      setIsSubmitting(true);
      const config = { timeout: 0 };
      const response = await post(
        "ocr/extractStatements",
        {
          appId: applicationId,
          mediaAttachmentIds: selectedFiles,
        },
        config
      );

      const successCount = response?.successCount;
      const failedCount = response?.failedCount;

      if (failedCount === 0 && successCount > 0) {
        setAlert({
          type: "success",
          message: (
            <>
              <strong>Files Accepted</strong>
              <br />
              Track processing status with the <strong>"Info"</strong> button at the top. <br />
              Please <strong>"Refresh"</strong> once processing is completed.
              <br />
            </>
          ),
          timeOut: 30000,
        });
      } else if (failedCount > 0 && successCount > 0) {
        setAlert({
          type: "warning",
          message: (
            <>
              <strong>Only {successCount} file(s) accepted.</strong> <br />
              Track processing status with the <strong>"Info"</strong> button at the top. <br />
              Please <strong>"Refresh"</strong> once processing is completed.
              <br />
            </>
          ),
          timeOut: 30000,
        });
      } else if (failedCount > 0 && successCount === 0) {
        setAlert({
          type: "error",
          message: "Error occurred during submission",
        });
      }
    } catch (error) {
      console.error("Error submitting files:", error);
      setAlert({
        type: "error",
        message: "An error occurred while processing with OCR.",
      });
    } finally {
      setIsSubmitting(false);
      setIsUploading(false);
    }
  };

  const runLendPathway = async () => {
    if (selectedFiles.length === 0) {
      setAlert({
        type: "warning",
        message: "Please select files before submitting.",
      });
      return;
    }

    try {
      setIsSubmitting(true);

      const response = await post(
        "integration/lend-pathway/extractStatements",
        {
          appId: applicationId,
          mediaAttachmentIds: selectedFiles,
        },
        { timeout: 0 }
      );

      const { status, message, data, error } = response?.data ?? {};

      if (status === "success") {
        setAlert({
          type: "success",
          message: (
            <>
              <strong>Files successfully uploaded.</strong>
              <br />
              LendPathway is now <strong>processing the files</strong>.
              <br />
            </>
          ),
          timeOut: 40000,
        });
      } else if (status === "processing") {
        setAlert({
          type: "success",
          message: "Files submitted. LendPathway is now processing the files",
        });
      } else if (status === "error") {
        setAlert({
          type: "error",
          message:
            message || (Array.isArray(error) && error.length > 0 ? error[0] : "An error occurred."),
        });
      }
    } catch (err) {
      console.error("Error submitting files:", err);
      setAlert({
        type: "error",
        message: "An unexpected error occurred while uploading.",
      });
    } finally {
      setIsSubmitting(false);
      setIsUploading(false);
      setShowLendPathway(false);
    }
  };

  const resendStatements = async (requestId) => {
    try {
      const response = await post(`ocr/resendStatements/${requestId}`);

      if (response?.status === "success") {
        setAlert({
          type: "success",
          message: "Request successfully resent.",
        });
        return { status: "success", message: "OCR request sent successfully" };
      } else {
        setAlert({
          type: "error",
          message: "Error occurred while resending the request.",
        });
      }
    } catch (error) {
      setAlert({
        type: "error",
        message: "An error occurred while resending the request. Please try again.",
      });
    }
  };

  const fetchOCRLogs = async () => {
    try {
      setIsSubmitting(true);
      const response: any = await get(`ocr/requests/${applicationId}`);
      const formattedLogs = response.map((log: any) => ({
        ...log,
        lastStatusUpdate: new Date(log.lastStatusUpdate).toLocaleString(),
      }));
      setOcrLogs(formattedLogs);
    } catch (error) {
      console.error("Error fetching logs:", error);
      setAlert({
        type: "error",
        message: "An error occurred while fetching OCR logs.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const setAlertMessage = (message: string) => {
    setAlert({
      type: "error",
      message: message,
    });
  };

  const setSuccessMessage = (message: string) => {
    setAlert({
      type: "success",
      message: message,
    });
  };

  const setBank = (bank: any) => {
    setSelectedBank(bank);
  };

  const RotatingHourglass = styled(HourglassEmptyIcon)(({ theme }) => ({
    color: "orange",
    fontSize: "medium",
    animation: "rotate 1s linear infinite",
    "@keyframes rotate": {
      "0%": {
        transform: "rotate(0deg)",
      },
      "100%": {
        transform: "rotate(360deg)",
      },
    },
  }));

  const handleResendRequest = (status) => {
    const initialMessage = "Are you sure you want to resend the request?";

    const message =
      status && status === "processing"
        ? `${initialMessage} Resending the request will result in additional processing time.`
        : initialMessage;
    const isConfirmed = window.confirm(message);

    if (isConfirmed) {
      resendStatements(log?.requestId)
        .then(() => fetchOCRLogs())
        .catch((error) => console.error("Failed to resend request:", error));
    }
  };

  const renderOCRLogs = () => {
    if (ocrLogs && ocrLogs.length > 0) {
      const rows = ocrLogs.map((log: any) => {
        const icon =
          log?.status === "completed" ? (
            <CheckCircleIcon style={{ color: "green" }} fontSize="medium" />
          ) : log?.status === "processing" ? (
            <RotatingHourglass />
          ) : (
            <CancelIcon style={{ color: "red" }} fontSize="medium" />
          );
        return {
          "Last Status": [
            icon,
            log?.lastStatusUpdate ? ExcelExportUtil.formatLocalDate(log?.lastStatusUpdate) : "-",
          ],
          File: log?.fileName,
          Status: log?.status,
          Reason: log?.status === "failed" ? log?.failedReason : "-",
          Actions: (
            <Tooltip title="Resend Request">
              <IconButton
                onClick={() => {
                  handleResendRequest(log?.status);
                }}
                color="primary"
              >
                <SendTimeExtension fontSize="small" />
              </IconButton>
            </Tooltip>
          ),
        };
      });

      return <StatusTable title="" rows={rows} />;
    }

    return <div>No OCR logs found</div>;
  };

  return (
    <MDBox display="flex" justifyContent="flex-start" alignItems="center" width="100%" p={2}>
      {isSubmitting && <FullPageLoader />}

      <MDBox display="flex" alignItems="center" gap={2}>
        {uploadingFiles.length > 0 ? (
          <MDProgress value={100} variant="contained" label />
        ) : (
          <MDDropzone
            title={"Drag and drop statement files here, or click to select."}
            onDropFile={handleFileDrop}
          />
        )}
      </MDBox>

      {alert && (
        <MDSnackbar
          color={
            alert?.type === "success" ? "success" : alert?.type === "warning" ? "warning" : "error"
          }
          icon="notifications"
          title={
            alert?.type === "success" ? "Success" : alert?.type === "warning" ? "Warning" : "Error"
          }
          content={alert?.message}
          dateTime=""
          autoHideDuration={alert?.timeOut || 5000}
          open={alert !== null}
          close={() => setAlert(null)}
        />
      )}

      <MDBox marginLeft={2} display="flex" alignItems="center" gap={2}>
        {StorageUtils.isFeatureEnabled("bank_account_integration") && (
          <PlaidComponent
            merchantId={merchantId}
            dealApplicationId={applicationId}
            publicToken={publicToken}
            loadBanksFromServer={loadBanksFromServer}
            setAlert={setAlertMessage}
            setSuccessAlert={setSuccessMessage}
            setBank={setBank}
            handleAccountRefresh={handleAccountRefresh}
            plaidBanks={plaidBanks}
            plaidApiError={plaidApiError}
            setPlaidApiError={setPlaidApiError}
          />
        )}

        {StorageUtils.isFeatureEnabled("flinks") && (
          <FlinksComponent
            merchantId={merchantId}
            dealApplicationId={applicationId}
            loadFlinksBanksFromServer={loadFlinksBanksFromServer}
            setAlert={setAlertMessage}
            setSuccessAlert={setSuccessMessage}
            setBank={setBank}
            handleAccountRefresh={handleAccountRefresh}
            flinksBanks={flinksBanks}
            flinksApiError={flinksApiError}
            setFlinksApiError={setFlinksApiError}
          />
        )}

        {StorageUtils.isFeatureEnabled("ocr") && (
          <MDButton
            variant="gradient"
            color="primary"
            onClick={() => {
              setShowOCRPopUp(true);
            }}
          >
            Read PDF
          </MDButton>
        )}

        {StorageUtils.isFeatureEnabled("moneyThumb") && (
          <MDButton variant="gradient" color="primary" onClick={handleOpen}>
            Run MoneyThumb
          </MDButton>
        )}

        {StorageUtils.isFeatureEnabled("lendPathway") && (
          <MDButton
            variant="gradient"
            color="primary"
            onClick={() => {
              setShowLendPathway(true);
            }}
          >
            Run LendPathway
          </MDButton>
        )}

        {StorageUtils.isFeatureEnabled("ocrolus") && (
          <MDButton
            variant="gradient"
            color="primary"
            onClick={() => {
              setShowOcrolous(true);
            }}
          >
            Run Ocrolus
          </MDButton>
        )}

        {/* { StorageUtils.isFeatureEnabled('ocr') &&
          <MDButton
            variant="gradient"
            color="primary"
            onClick={() => setShowOcrTransactionsModal(true)}
          >
            Run Analysis
          </MDButton>
        } */}

        {StorageUtils.isFeatureEnabled("ocr") && (
          <Tooltip title="Track OCR Requests" arrow>
            <IconButton
              size={"large"}
              sx={{ marginLeft: -1, color: "#2F929F" }}
              onClick={() => {
                fetchOCRLogs().then(() => {
                  setShowOCRLogs(true);
                });
              }}
            >
              <InfoIcon fontSize={"large"} />
            </IconButton>
          </Tooltip>
        )}

        <Tooltip title="Refresh All" arrow>
          <IconButton
            size={"large"}
            sx={{ marginLeft: -3, color: "#2F929F" }}
            onClick={() => refreshAll(applicationId)}
          >
            <RefreshIcon fontSize={"large"} />
          </IconButton>
        </Tooltip>
      </MDBox>

      <CustomModal
        open={open}
        onClose={handleClose}
        title="Upload Bank Statements (MoneyThumb)"
        cancelText="Cancel"
        submitText="Submit"
        onCancel={handleClose}
        onSubmit={handleSubmit}
        maxWidth="sm"
        fullWidth={true}
      >
        <MDBox display="flex" flexDirection="column" width="100%">
          <Autocomplete
            multiple
            id="file-select"
            options={files
              .filter((file) => !selectedFiles.includes(file.id))
              .map((file) => ({
                value: file.id,
                label: file.name,
              }))}
            getOptionLabel={(option) => option.label}
            value={files
              .filter((file) => selectedFiles.includes(file.id))
              .map((file) => ({
                value: file.id,
                label: file.name,
              }))}
            onChange={handleFileSelect}
            disableCloseOnSelect
            renderInput={(params) => <TextField {...params} label="Select Files" />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            style={{ marginBottom: "15px", marginTop: "15px" }}
          />
        </MDBox>
      </CustomModal>

      <CustomModal
        open={showOCRPopUp}
        onClose={() => {
          setSelectedFiles([]);
          setShowOCRPopUp(false);
        }}
        title="Upload Bank Statements (OCR)"
        cancelText="Cancel"
        submitText="Submit"
        onCancel={() => {
          setSelectedFiles([]);
          setShowOCRPopUp(false);
        }}
        onSubmit={handleRunOcr}
        maxWidth="sm"
        fullWidth={true}
      >
        <MDBox display="flex" flexDirection="column" width="100%">
          <Autocomplete
            multiple
            id="file-select"
            options={files
              .filter((file) => !selectedFiles.includes(file.id))
              .map((file) => ({
                value: file.id,
                label: file.name,
              }))}
            getOptionLabel={(option) => option.label}
            value={files
              .filter((file) => selectedFiles.includes(file.id))
              .map((file) => ({
                value: file.id,
                label: file.name,
              }))}
            onChange={handleFileSelect}
            disableCloseOnSelect
            renderInput={(params) => <TextField {...params} label="Select Files" />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            style={{ marginBottom: "15px", marginTop: "15px" }}
          />
        </MDBox>
      </CustomModal>

      <CustomModal
        open={showLendPathway}
        onClose={() => {
          setSelectedFiles([]);
          setShowLendPathway(false);
        }}
        title="Upload Bank Statements (Lend Pathway)"
        cancelText="Cancel"
        submitText="Submit"
        onCancel={() => {
          setSelectedFiles([]);
          setShowLendPathway(false);
        }}
        onSubmit={runLendPathway}
        maxWidth="sm"
        fullWidth={true}
      >
        <MDBox display="flex" flexDirection="column" width="100%">
          <Autocomplete
            multiple
            id="file-select"
            options={files
              .filter((file) => !selectedFiles.includes(file.id))
              .map((file) => ({
                value: file.id,
                label: file.name,
              }))}
            getOptionLabel={(option) => option.label}
            value={files
              .filter((file) => selectedFiles.includes(file.id))
              .map((file) => ({
                value: file.id,
                label: file.name,
              }))}
            onChange={handleFileSelect}
            disableCloseOnSelect
            renderInput={(params) => <TextField {...params} label="Select Files" />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            style={{ marginBottom: "15px", marginTop: "15px" }}
          />
        </MDBox>
      </CustomModal>

      {/* OCR Modal */}
      <CustomModal
        open={showOcrTransactionsModal}
        onClose={() => setShowOcrTransactionsModal(false)}
        title="Select Accounts for OCR Processing"
        cancelText="Cancel"
        submitText="Submit to OCR"
        onCancel={() => setShowOcrTransactionsModal(false)}
        onSubmit={onRunOcrTransactions}
        maxWidth="md"
        fullWidth={true}
      >
        {renderOcrAccountSelection()}
      </CustomModal>

      <CustomDialog
        open={showOCRLogs}
        onClose={() => {
          setShowOCRLogs(false);
        }}
        title="OCR Request Logs"
      >
        {renderOCRLogs()}
      </CustomDialog>

      <CustomModal
        open={showOcrolous}
        onClose={() => {
          setSelectedFiles([]);
          setShowOcrolous(false);
        }}
        title="Upload Bank Statements (Ocrolous)"
        cancelText="Cancel"
        submitText="Submit"
        onCancel={() => {
          setSelectedFiles([]);
          setShowOcrolous(false);
        }}
        onSubmit={runOcrolous}
        maxWidth="sm"
        fullWidth={true}
      >
        <MDBox display="flex" flexDirection="column" width="100%">
          <Autocomplete
            multiple
            id="file-select"
            options={files
              .filter((file) => !selectedFiles.includes(file.id))
              .map((file) => ({
                value: file.id,
                label: file.name,
              }))}
            getOptionLabel={(option) => option.label}
            value={files
              .filter((file) => selectedFiles.includes(file.id))
              .map((file) => ({
                value: file.id,
                label: file.name,
              }))}
            onChange={handleFileSelect}
            disableCloseOnSelect
            renderInput={(params) => <TextField {...params} label="Select Files" />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            style={{ marginBottom: "15px", marginTop: "15px" }}
          />
        </MDBox>
      </CustomModal>
    </MDBox>
  );
};

export default StatementsToolbar;
